import DataGridRow from '@components/primitives/dataGrid/DataGridRow';
import { Table } from '@tanstack/table-core';
import { DataGridRowProps } from '@components/primitives/dataGrid/DataGrid';
import { Row } from '@tanstack/react-table';
import DataGridCell from '@components/primitives/dataGrid/DataGridCell';
import { ReactNode } from 'react';

interface Props<TData> {
    table: Table<TData>;
    selectedRow?: string;
    setActiveRow?: (activeRow: string | undefined, index: number) => void;
    selectedCell?: keyof TData;
    getRowProps?: (row: Row<TData>) => object;
    onCellClick?: (row: Row<TData>, columnId: keyof TData) => void;
    placeholderRowDisabled?: boolean;
    onPlaceholderRowClick?: () => void;
    noRowsMessage?: ReactNode;
}

const DataGridBody = <TData extends DataGridRowProps>({
    table,
    selectedRow,
    setActiveRow,
    selectedCell,
    getRowProps,
    onCellClick,
    placeholderRowDisabled,
    onPlaceholderRowClick,
    noRowsMessage,
}: Props<TData>) => {
    return (
        <>
            {table.getRowModel().rows.length ? (
                <div className="dataGrid__body">
                    {table.getRowModel().rows.map((row, index) => (
                        <DataGridRow<TData> key={row.id} row={row} index={index} setActiveRow={setActiveRow} isSelected={row.id === selectedRow} getRowProps={getRowProps}>
                            {row.getVisibleCells().map((cell) => (
                                <DataGridCell<TData>
                                    key={cell.id}
                                    cell={cell}
                                    row={row}
                                    isSelected={selectedCell === cell.column.id && selectedRow === row.id}
                                    onCellClick={onCellClick}
                                />
                            ))}
                        </DataGridRow>
                    ))}
                    {onPlaceholderRowClick && table.getState().pagination.pageIndex === table.getPageCount() - 1 && (
                        <button tabIndex={-1} type="button" className="dataGrid__placeholderRow" onClick={onPlaceholderRowClick} disabled={placeholderRowDisabled} />
                    )}
                </div>
            ) : noRowsMessage ? (
                <div className="dataGrid__body dataGrid__body--empty">{noRowsMessage}</div>
            ) : null}
        </>
    );
};

export default DataGridBody;
